import { AuthState } from "./types";

export const state: AuthState = {
  usuario: null,
  isLogged: false,
};